/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useEffect, useState } from "react";
import { connect } from "react-redux";

import { TabPanel, TabView } from "primereact/tabview";

// Dashboard components
import MDBox from "components/MDBox";

// Dashboard example components
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// @mui material components
import Grid from "@mui/material/Grid";

import { getSubModulesByRoleId } from "../../store";

import Cookies from "universal-cookie";

import QARSTW from "./QARSTW";
import AcceptedQuarantinesW1 from "./QARSTW1/accepted-quarantines";
import AcceptedQuarantinesW2 from "./QARSTW2/accepted-quarantines";
import AcceptedQuarantinesW3 from "./QARSTW3/accepted-quarantines";

const cookies = new Cookies();

const RejectionsParent = ({
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");
  let jwtToken = loginDetails?.jwt;
  let roleId = loginDetails.data.roleId;

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  let QARSTWAccess = modulesData.find(
    (moduleId) => moduleId.moduleId == "36d4fab2-0c14-4ae5-bd8a-93cb38a7d8e5",
  );

  let QARSTW1Access = modulesData.find(
    (moduleId) => moduleId.moduleId == "3b897e73-9fa6-40a1-82ff-21f04d1c1101",
  );

  let QARSTW2Access = modulesData.find(
    (moduleId) => moduleId.moduleId == "47c61432-3c8e-4b04-a9b4-7bc989bab18a",
  );

  let QARSTW3Access = modulesData.find(
    (moduleId) => moduleId.moduleId == "fe86eaa1-6299-4619-8b6f-1b1b21682410",
  );

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={2} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            {QARSTWAccess ? (
              <QARSTW />
            ) : QARSTW1Access ? (
              <TabView>
                <TabPanel header="Accepted List">
                  <AcceptedQuarantinesW1 />
                </TabPanel>
              </TabView>
            ) : QARSTW2Access ? (
              <TabView>
                <TabPanel header="Accepted List">
                  <AcceptedQuarantinesW2 />
                </TabPanel>
              </TabView>
            ) : QARSTW3Access ? (
              <TabView>
                <TabPanel header="Accepted List">
                  <AcceptedQuarantinesW3 />
                </TabPanel>
              </TabView>
            ) : (
              <>
                <h4 style={{ textAlign: "center", marginTop: "6rem" }}>
                  No Quarantine Access
                </h4>
              </>
            )}
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
  };
};

const mapStateToDispatch = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
  };
};

export default connect(mapStateToProps, mapStateToDispatch)(RejectionsParent);
